<template>
  <div id="subject">
    <!-- <div class="left">
            <div class="btn-close" @click="goHome()">
                <img src="/themes/web/assets/images/icon/icon-rectangle.svg" alt="">
            </div>
        </div> -->
    <div class="right" style="left: 130px">
      <!-- <div class="tool-tip-complete">
                                
            </div> -->
      <div class="header">
        <div class="left-header">
          <div style="display: flex; justify-content: space-between">
            <p class="desc">You're studying</p>
            <p :class="is_structured == 1 ? 'structured' : 'non-structured'">
              {{
                is_structured == 1
                  ? "Structured Learning"
                  : "Unstructured Learning"
              }}
            </p>
          </div>
          <div class="title-subject">
            <h4>{{ course_name }}</h4>
            <img @click="changeCourse()" style="cursor: pointer" src="/themes/web/assets/images/icon/icon-back.svg"
              alt="" />
          </div>
          <div class="pace" style="
              display: flex;
              padding: 4px;
              align-items: center;
              border-radius: 16px;
              background: var(--Creme-Dark, #f8fafc);
              justify-content: space-between;
            ">
            <!-- <p class="p-pace-1">Grades</p> -->
            <div style="
                display: flex;
                justify-content: space-between;
                padding: 8px;
                align-items: center;
                border-radius: 16px;
                background: var(--Creme-Light, #fff);
                gap: 8px;
              ">
              <p class="p-pace">Current Grade</p>
              <div class="circle-pace">
                <p>{{ current_grade }}%</p>
              </div>
            </div>
            <div style="
                display: flex;
                justify-content: space-between;
                padding: 8px;
                align-items: center;
                border-radius: 16px;
                background: var(--Creme-Light, #fff);
                gap: 8px;
              ">
              <p class="p-pace">Course Grade</p>
              <div class="circle-pace-1">
                <p>{{ course_grade }}%</p>
              </div>
            </div>
            <div class="icon-info" style="position: relative">
              <img src="/themes/web/assets/images/icon/icon-info.svg" alt="" />
              <div class="tool-tip-info">
                <p>
                  <b>Current Grade:</b> This is the grade the student has earned
                  for the work completed and scored to date.
                </p>
                <p>
                  <b>Course Grade:</b> This is the final grade the student will
                  earn for the course.
                </p>
              </div>
            </div>
          </div>
          <div class="progress">
            <!-- { width: moduleCurent.total!=0 ? moduleCurent.process/moduleCurent.total*100 + '%' : 100+'%' } -->
            <!-- <div class="progress-load">
                            <div v-if="pacing == 1" @mouseover="showStatusPace(1)" @mouseout="hideStatusPace(1)" class="status-pace">
                                <div class="line-pace"></div>
                                <div class="tool-tip-pace">
                                    <p>You’re on good pace.</p>
                                </div>
                            </div>

                            <div v-else-if="pacing == 0" @mouseover="showStatusPace(2)" @mouseout="hideStatusPace(2)" class="status-pace slow">
                                <div class="line-pace slow"></div>
                                <div class="tool-tip-pace slow">
                                    <p>You’re slow</p>
                                </div>
                            </div>

                            <div v-else-if="pacing == 2" @mouseover="showStatusPace(3)" @mouseout="hideStatusPace(3)" class="status-pace fast">
                                <div class="line-pace fast"></div>
                                <div class="tool-tip-pace fast">
                                    <p>You’re learning fast!</p>
                                </div>
                            </div>
                        </div> -->
          </div>
        </div>
        <div v-if="is_structured" class="right-header">
          <div v-for="(module, index) in modules" :key="module.id" @click="changeModule(module, index)">
            <div v-if="module.status == 'completed'" style="display: flex; align-items: center; gap: 8px">
              <div style="position: relative; width: 80px">
                <img class="icon-status" src="/themes/web/assets/images/icon/icon-status.svg" alt="" />
                <div :class="module.id == moduleCurent.id
                  ? 'theme-item active'
                  : 'theme-item'
                  ">
                  <img v-if="module.type_code == 'module'" :src="module.module_img" alt="" />
                  <img v-else :src="module.module_img && module.module_img != ''
                    ? module.module_img
                    : default_semeter_img
                    " alt="" />
                </div>
                <p v-if="module.type_code == 'module'" :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Module {{ index + 1 }}
                </p>
                <p v-else :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Final Test {{ module.index_semester }}
                </p>
              </div>
              <div v-if="modules.length != index + 1" class="dot active"></div>
            </div>

            <div v-else-if="module.lock == 0 && is_started == 1" style="display: flex; align-items: center; gap: 8px">
              <div style="position: relative; width: 80px">
                <img class="icon-status" src="/themes/web/assets/images/icon/icon-unlock.svg" alt="" />
                <!-- <div :class="module.id == moduleCurent.id ? 'theme-item active' : 'theme-item'">
                                    <img :src="course_img" alt="">
                                </div> -->
                <!-- <popper trigger="hover" :options="{ placement: 'bottom'}">
                                    <div class="popper">
                                        <div class="tool-tip-complete">
                                            <p>You must complete this activity before: <b>22:00 July 6th (Today)</b></p>
                                        </div>
                                    </div>
                                    <span slot="reference">
                                        <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id ? 'theme-item active' : 'theme-item'">
                                            <img :src="module.module_img" alt="">
                                        </div>
                                    </span>
                                </popper> -->
                <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id
                  ? 'theme-item active'
                  : 'theme-item'
                  ">
                  <img v-if="module.type_code == 'module'" :src="module.module_img" alt="" />
                  <img v-else :src="module.module_img && module.module_img != ''
                    ? module.module_img
                    : default_semeter_img
                    " alt="" />
                </div>
                <p v-if="module.type_code == 'module'" :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Module {{ index + 1 }}
                </p>
                <p v-else :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Final Test {{ module.index_semester }}
                </p>
              </div>
              <div v-if="modules.length != index + 1" class="dot"></div>
            </div>

            <div v-else-if="module.lock == 1 || is_started == 0" style="
                display: flex;
                align-items: center;
                gap: 8px;
                position: relative;
              ">
              <div style="position: relative; width: 80px">
                <img class="icon-status" src="/themes/web/assets/images/icon/icon-lock-1.svg" alt="" />
                <!-- <popper trigger="hover" :options="{ placement: 'bottom'}">
                                    <div class="popper">
                                        <div class="tool-tip-complete">
                                            <p>You must complete this activity before: <b>22:00 July 6th (Today)</b></p>
                                        </div>
                                    </div>
                                    <span slot="reference">
                                        <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id ? 'theme-item active' : 'theme-item'">
                                            <img class="img-inactive" :src="module.module_img" alt="">
                                        </div>
                                    </span>
                                </popper> -->
                <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id
                  ? 'theme-item active'
                  : 'theme-item'
                  ">
                  <img class="img-inactive" v-if="module.type_code == 'module'" :src="module.module_img" alt="" />
                  <img class="img-inactive" v-else :src="module.module_img && module.module_img != ''
                    ? module.module_img
                    : default_semeter_img
                    " alt="" />
                </div>
                <p v-if="module.type_code == 'module'" :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Module {{ index + 1 }}
                </p>
                <p v-else :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Final Test {{ module.index_semester }}
                </p>
              </div>
              <div v-if="modules.length != index + 1" class="dot"></div>
            </div>
          </div>
        </div>
        <div v-else class="right-header free-study">
          <div v-for="(module, index) in modules" :key="module.id" @click="changeModule(module, index)">
            <!-- <div v-if="module.status == 'completed'" style="display: flex; align-items: center; gap: 8px;">
                            <div style="position: relative; width: 80px;">
                                <div :class="module.id == moduleCurent.id ? 'theme-item active' : 'theme-item completed'">
                                    <img :src="module.module_img" alt="">
                                    <div class="info-progress completed">
                                        <p>{{ module.precent_progress }}%</p>
                                    </div>
                                </div>
                                <p v-if="module.type_code == 'module'" class="name-theme">Module {{ index + 1 }}</p>
                                <p v-else class="name-theme">Final Test</p>
                            </div>
                            <div v-if="modules.length != index+1" class="dot active"></div>
                        </div>

                        <div v-else-if="module.lock == 0" style="display: flex; align-items: center; gap: 8px;">
                            <div style="position: relative; width: 80px;">
                                <div :class="module.id == moduleCurent.id ? 'theme-item active' : ( module.precent_progress == 0 ? 'theme-item not-start' : 'theme-item ongoing')">
                                    <img :src="module.module_img" alt="">
                                    <div :class="module.precent_progress == 0 ? 'info-progress not-start' : 'info-progress inprogress'">
                                        <p>{{ module.precent_progress }}%</p>
                                    </div>
                                </div>
                                <p v-if="module.type_code == 'module'" class="name-theme">Module {{ index + 1 }}</p>
                                <p v-else class="name-theme">Final Test</p>
                            </div>
                            <div v-if="modules.length != index+1" class="dot"></div>
                        </div> -->

            <div v-if="module.status == 'completed'" style="display: flex; align-items: center; gap: 8px">
              <div style="position: relative; width: 80px">
                <img class="icon-status" src="/themes/web/assets/images/icon/icon-status.svg" alt="" />
                <div :class="module.id == moduleCurent.id
                  ? 'theme-item active'
                  : 'theme-item'
                  ">
                  <img v-if="module.type_code == 'module'" :src="module.module_img" alt="" />
                  <img v-else :src="module.module_img && module.module_img != ''
                    ? module.module_img
                    : default_semeter_img
                    " alt="" />
                </div>
                <p v-if="module.type_code == 'module'" :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Module {{ index + 1 }}
                </p>
                <p v-else :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Final Test {{ module.index_semester }}
                </p>
              </div>
              <div v-if="modules.length != index + 1" class="dot active"></div>
            </div>

            <div v-else-if="module.lock == 0 && is_started == 1" style="display: flex; align-items: center; gap: 8px">
              <div style="position: relative; width: 80px">
                <!-- <img class="icon-status" src="/themes/web/assets/images/icon/icon-unlock.svg" alt=""> -->
                <!-- <div :class="module.id == moduleCurent.id ? 'theme-item active' : 'theme-item'">
                                    <img :src="course_img" alt="">
                                </div> -->
                <!-- <popper trigger="hover" :options="{ placement: 'bottom'}">
                                    <div class="popper">
                                        <div class="tool-tip-complete">
                                            <p>You must complete this activity before: <b>22:00 July 6th (Today)</b></p>
                                        </div>
                                    </div>
                                    <span slot="reference">
                                        <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id ? 'theme-item active' : 'theme-item'">
                                            <img :src="module.module_img" alt="">
                                        </div>
                                    </span>
                                </popper> -->
                <!-- <img v-if="module.type_code != 'module'" class="icon-status" src="/themes/web/assets/images/icon/icon-unlock.svg" alt=""> -->
                <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id
                  ? 'theme-item active'
                  : 'theme-item'
                  ">
                  <img v-if="module.type_code == 'module'" :src="module.module_img" alt="" />
                  <img v-else :src="module.module_img && module.module_img != ''
                    ? module.module_img
                    : default_semeter_img
                    " alt="" />
                </div>
                <p v-if="module.type_code == 'module'" :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Module {{ index + 1 }}
                </p>
                <p v-else :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Final Test {{ module.index_semester }}
                </p>
              </div>
              <div v-if="modules.length != index + 1" class="dot"></div>
            </div>

            <div v-else-if="is_started == 0" style="
                display: flex;
                align-items: center;
                gap: 8px;
                position: relative;
              ">
              <div style="position: relative; width: 80px">
                <img class="icon-status" src="/themes/web/assets/images/icon/icon-lock-1.svg" alt="" />
                <!-- <popper trigger="hover" :options="{ placement: 'bottom'}">
                                    <div class="popper">
                                        <div class="tool-tip-complete">
                                            <p>You must complete this activity before: <b>22:00 July 6th (Today)</b></p>
                                        </div>
                                    </div>
                                    <span slot="reference">
                                        <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id ? 'theme-item active' : 'theme-item'">
                                            <img class="img-inactive" :src="module.module_img" alt="">
                                        </div>
                                    </span>
                                </popper> -->
                <img v-if="module.type_code != 'module'" class="icon-status"
                  src="/themes/web/assets/images/icon/icon-unlock.svg" alt="" />
                <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id
                  ? 'theme-item active'
                  : 'theme-item'
                  ">
                  <img class="img-inactive" v-if="module.type_code == 'module'" :src="module.module_img" alt="" />
                  <img class="img-inactive" v-else :src="module.module_img && module.module_img != ''
                    ? module.module_img
                    : default_semeter_img
                    " alt="" />
                </div>
                <p v-if="module.type_code == 'module'" :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Module {{ index + 1 }}
                </p>
                <p v-else :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Final Test {{ module.index_semester }}
                </p>
              </div>
              <div v-if="modules.length != index + 1" class="dot"></div>
            </div>

            <div v-else-if="module.lock == 1 || is_started == 0" style="
                display: flex;
                align-items: center;
                gap: 8px;
                position: relative;
              ">
              <div style="position: relative; width: 80px">
                <img class="icon-status" src="/themes/web/assets/images/icon/icon-lock-1.svg" alt="" />
                <div @mouseover="showToolTipModule($event)" :class="module.id == moduleCurent.id
                  ? 'theme-item active'
                  : 'theme-item'
                  ">
                  <img class="img-inactive" v-if="module.type_code == 'module'" :src="module.module_img" alt="" />
                  <img class="img-inactive" v-else :src="module.module_img && module.module_img != ''
                    ? module.module_img
                    : default_semeter_img
                    " alt="" />
                </div>
                <p v-if="module.type_code == 'module'" :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Module {{ index + 1 }}
                </p>
                <p v-else :class="module.id == moduleCurent.id
                  ? 'name-theme active'
                  : 'name-theme'
                  ">
                  Final Test {{ module.index_semester }}
                </p>
              </div>
              <div v-if="modules.length != index + 1" class="dot"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="body">
        <div class="content-left">
          <div class="theme-card">
            <img :src="course_img != ''
              ? course_img
              : '/themes/web/assets/images/default-course.png'
              " alt="" />
            <div class="status-unit-list">
              <!-- <div v-for="(unit, index) in units" :key="unit.id"  @click="changeLesson(lesson, index)" >
                                <div v-if="unit.status == 'unlock'" :class="unit.id == lessonCurrent.id ? 'status-desc unlock active' : 'status-desc unlock'">
                                    <div>
                                        <img src="/themes/web/assets/images/icon/icon-unlock-unit.svg" alt="">
                                    </div>
                                    <span>Unit {{ index + 1 }}</span>
                                </div>

                                <div v-if="unit.status == 'lock'" :class="unit.id == lessonCurrent.id ? 'status-desc lock active' : 'status-desc lock'">
                                    <div>
                                        <img src="/themes/web/assets/images/icon/icon-lock-unit.svg" alt="">
                                    </div>
                                    <span>Unit {{ index + 1 }}</span>
                                </div>

                                <div v-if="unit.status == 'completed'" :class="unit.id == lessonCurrent.id ? 'status-desc checked active' : 'status-desc checked'">
                                    <div>
                                        <img src="/themes/web/assets/images/icon/icon-checked-unit.svg" alt="">
                                    </div>
                                    <span>Unit {{ index + 1 }}</span>
                                </div>
                            </div> -->
            </div>
          </div>
          <div class="unit-details">
            <!-- <p>Module {{indexModule}}/{{ modules.length }}</p> -->
            <!-- <h4>{{ course_name }}</h4> -->
            <div>
              <p v-if="course_desc" :style="{ whiteSpace: 'pre-wrap' }">
                {{ displayText }}
                <span v-if="isTruncated" @click="seeMore()" style="cursor: pointer">
                  {{ showMore ? "See less" : "See more" }}
                </span>
              </p>
            </div>

            <p class="expire" v-if="comming_expire">
              This course will be expired on {{ displayDate }}
            </p>

            <button class="gradebook-button" @click="viewGradebook()">
              View Gradebook
            </button>
          </div>
        </div>
        <div v-if="moduleCurent.type_code == 'module'" class="content-right" style="width: 100%">
          <div class="desc-unit">
            <h2>{{ moduleCurent.module_name }}</h2>
            <div class="number-unit">
              <div>
                <img src="/themes/web/assets/images/icon/icon-lesson.svg" alt="" />
                <p>
                  <b>{{
                    moduleCurent.lessons ? moduleCurent.lessons.length : 0
                  }}</b>
                  <span> {{
                    moduleCurent.lessons.length == 1 ||
                      moduleCurent.lessons.length == 0
                      ? "Lesson"
                      : "Lessons"
                  }}</span>
                </p>
              </div>
              <div>
                <img src="/themes/web/assets/images/icon/icon-assignment.svg" alt="" />
                <p>
                  <b>{{ moduleCurent.total_test }}</b>
                  <span> {{
                    moduleCurent.total_test == 1 || moduleCurent.total_test == 0
                      ? "Test"
                      : "Tests"
                  }}</span>
                </p>
              </div>
              <div v-if="moduleCurent.desc" @click="showModuleDesc()"
                style="justify-content: end; flex: 1; cursor: pointer">
                <img src="/themes/web/assets/images/icon/icon-info1.svg" alt="" />
              </div>
            </div>
            <!-- <p>{{ moduleCurent.desc }}</p> -->
          </div>
          <div v-if="is_structured" class="list-lesson">
            <div v-for="(lesson, index) in moduleCurent.lessons" :key="lesson.id">
              <div v-if="lesson.status == 'completed'" class="lesson-item completed">
                <!-- <p class="id-lesson">{{ module.id }}</p> -->
                <!-- <div class="img-lesson">
                                    <img :src="lesson.lesson_img" alt="">
                                </div> -->
                <div class="desc-lesson">
                  <div class="title-lesson">
                    <!-- <img src="/themes/web/assets/images/icon/icon-checked.svg" alt=""> -->
                    <span>Lesson {{ index + 1 }}</span>
                  </div>
                  <h4>{{ lesson.lesson_name }}</h4>
                </div>
                <div class="btn-play">
                  <div>
                    <p class="status-lesson">Completed</p>
                    <p class="value-process">
                      {{ lesson.process }}/{{ lesson.total }} Packages
                    </p>
                  </div>
                  <router-link :to="{
                    path:
                      '/lesson-package/' +
                      class_id +
                      '/' +
                      course_id +
                      '-' +
                      moduleCurent.id +
                      '-' +
                      lesson.id,
                  }">
                    <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png"
                      alt="" />
                  </router-link>
                </div>
              </div>

              <div v-else-if="lesson.lock == 1 || is_started == 0" class="lesson-item notstart">
                <!-- <p class="id-lesson">{{ module.id }}</p> -->
                <!-- <div class="img-lesson">
                                    <img :src="lesson.lesson_img" alt="">
                                </div> -->
                <div class="desc-lesson">
                  <div class="title-lesson">
                    <img src="/themes/web/assets/images/icon/icon-lock-2.svg" alt="" />
                    <span>Lesson {{ index + 1 }}</span>
                  </div>
                  <h4>{{ lesson.lesson_name }}</h4>
                </div>
                <div class="btn-play">
                  <div class="btn-play">
                    <div>
                      <p class="status-lesson">Not started</p>
                      <p class="value-process">
                        {{ lesson.process }}/{{ lesson.total }} Packages
                      </p>
                    </div>
                    <img src="/themes/web/assets/images/icon/icon-play-2.svg" alt="" />
                  </div>
                </div>
              </div>

              <div v-else-if="lesson.lock == 0 && is_started == 1" class="lesson-item current">
                <!-- <p class="id-lesson">{{ module.id }}</p> -->
                <!-- <div class="img-lesson">
                                    <img src="/themes/web/assets/images/icon/theme-lesson.svg" alt="">
                                    <div class="tool-tip-complete">
                                        <p>You must complete this activity before: <b>22:00 July 6th (Today)</b></p>
                                    </div>
                                </div> -->
                <!-- <popper trigger="hover" :options="{ placement: 'top'}">
                                    <div class="popper-1">
                                        <div class="tool-tip-complete">
                                            <p>You must complete this activity before: <b>22:00 July 6th (Today)</b></p>
                                        </div>
                                    </div>
                                    <span slot="reference">
                                        <div class="img-lesson">
                                            <img :src="lesson.lesson_img" alt="">
                                        </div>
                                    </span>
                                </popper> -->
                <div class="desc-lesson">
                  <div class="title-lesson">
                    <!-- <img v-if="lesson.status == 'inprogress'" src="/themes/web/assets/images/icon/icon-fire.svg" alt="">
                                        <img v-else-if="lesson.status == 'not-started'" src="/themes/web/assets/images/icon/icon-lock-2.svg" alt=""> -->
                    <!-- <img src="/themes/web/assets/images/icon/icon-fire.svg" alt=""> -->
                    <span>Lesson {{ index + 1 }}</span>
                  </div>
                  <h4>{{ lesson.lesson_name }}</h4>
                </div>
                <div v-if="lesson.status == 'inprogress'" class="btn-play">
                  <div>
                    <p class="status-lesson">In-Progress</p>
                    <p class="value-process">
                      {{ lesson.process }}/{{ lesson.total }} Packages
                    </p>
                  </div>
                  <router-link :to="{
                    name: 'lesson-package',
                    params: {
                      course_id,
                      lesson_id: lesson.id,
                      module_id: moduleCurent.id,
                    },
                  }">
                    <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png"
                      alt="" />
                  </router-link>
                </div>
                <div v-else-if="lesson.status == 'not-started'" class="btn-play">
                  <!-- <div class="btn-play">
                                        <p class="status-lesson" style="color:#A35CDB">Not Started</p>
                                        <img style="width: 90px; cursor: pointer;" src="/themes/web/assets/images/icon/btn-play.png" alt="">
                                    </div> -->
                  <div>
                    <p class="status-lesson" style="color: #fc7a1b">To do</p>
                    <p class="value-process">
                      {{ lesson.process }}/{{ lesson.total }} Packages
                    </p>
                  </div>
                  <router-link :to="{
                    name: 'lesson-package',
                    params: {
                      course_id,
                      lesson_id: lesson.id,
                      module_id: moduleCurent.id,
                    },
                  }">
                    <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png"
                      alt="" />
                  </router-link>
                </div>
              </div>
            </div>
            <div v-if="
              tests && tests.lock == 0 && tests.id != 0 && is_started == 1
            " class="lesson-item current">
              <!-- <div class="img-lesson">
                                <img :src="tests.lesson_img" alt="">
                            </div> -->
              <div class="desc-lesson">
                <div class="title-lesson">
                  <!-- <img v-if="lesson.status == 'inprogress'" src="/themes/web/assets/images/icon/icon-fire.svg" alt="">
                                    <img v-else-if="lesson.status == 'not-started'" src="/themes/web/assets/images/icon/icon-lock-2.svg" alt=""> -->
                  <!-- <img src="/themes/web/assets/images/icon/icon-fire.svg" alt=""> -->
                  <span>End of Module</span>
                </div>
                <h4>{{ tests.test_name }}</h4>
              </div>
              <!-- <div v-if="tests.status == 'notpass'" class="btn-play">
                                <p class="status-lesson" style="color: #FC7A1B;">To do</p>
                                <div @click="doTest(tests)">
                                    <img style="width: 90px; cursor: pointer;" src="/themes/web/assets/images/icon/btn-play.png" alt="">
                                </div>
                            </div> -->
              <div v-if="tests.status == 'pass'" class="btn-play">
                <p class="status-lesson" style="color: #a35cdb">Completed</p>
                <div @click="doTest(tests)">
                  <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png" alt="" />
                </div>
              </div>
              <div v-else-if="tests.status == 'notpass'" class="btn-play">
                <div style="
                    display: flex;
                    align-items: end;
                    flex-direction: column;
                  ">
                  <p class="status-lesson" style="color: #a35cdb">Completed</p>
                  <p style="
                      color: #ff0000;
                      font-size: 12px;
                      text-wrap: nowrap;
                      margin-top: 7px;
                    ">
                    You did not pass this test
                  </p>
                </div>

                <div @click="doTest(tests)">
                  <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png" alt="" />
                </div>
              </div>
              <div v-else class="btn-play">
                <p class="status-lesson" v-if="tests.status == TestStatus.ON_GOING" style="color: #fc7a1b">
                  To do
                </p>
                <p class="status-lesson" v-else-if="tests.status == TestStatus.INPROGRESS" style="color: #58cc02">
                  In Progress
                </p>
                <p class="status-lesson" v-else-if="tests.status == TestStatus.SUBMITED" style="color: #a560eb">
                  Submitted
                </p>
                <p class="status-lesson" v-else-if="tests.status == TestStatus.COMPLETED" style="color: #a560eb">
                  Completed
                </p>
                <p class="status-lesson" v-else-if="tests.status == TestStatus.NEED_RESUBMIT" style="color: #fc7a1b">
                  Allow retry
                </p>
                <div @click="doTest(tests)">
                  <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png" alt="" />
                </div>
              </div>
            </div>
            <div v-else-if="
              (tests && tests.lock == 1 && tests.id != 0) ||
              (tests && is_started == 0)
            " class="lesson-item notstart">
              <!-- <div class="img-lesson">
                                <img :src="tests.lesson_img" alt="">
                            </div> -->
              <div class="desc-lesson">
                <div class="title-lesson">
                  <img src="/themes/web/assets/images/icon/icon-lock-2.svg" alt="" />
                  <span>End of Module</span>
                </div>
                <h4>{{ tests.test_name }}</h4>
              </div>
              <div class="btn-play">
                <div class="btn-play">
                  <p class="status-lesson">Not started</p>
                  <img src="/themes/web/assets/images/icon/icon-play-2.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="list-lesson">
            <div v-for="(lesson, index) in moduleCurent.lessons" :key="lesson.id">
              <div v-if="lesson.status == 'completed'" class="lesson-item completed">
                <!-- <p class="id-lesson">{{ module.id }}</p> -->
                <!-- <div class="img-lesson">
                                    <img :src="lesson.lesson_img" alt="">
                                </div> -->
                <div class="desc-lesson">
                  <div class="title-lesson">
                    <!-- <img src="/themes/web/assets/images/icon/icon-checked.svg" alt=""> -->
                    <span>Lesson {{ index + 1 }}</span>
                  </div>
                  <h4>{{ lesson.lesson_name }}</h4>
                </div>
                <div class="btn-play">
                  <div>
                    <p class="status-lesson">Completed</p>
                    <p class="value-process">
                      {{ lesson.process }}/{{ lesson.total }} Packages
                    </p>
                  </div>
                  <router-link :to="{
                    path:
                      '/lesson-package/' +
                      class_id +
                      '/' +
                      course_id +
                      '-' +
                      moduleCurent.id +
                      '-' +
                      lesson.id,
                  }">
                    <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png"
                      alt="" />
                  </router-link>
                </div>
              </div>

              <div v-else-if="lesson.lock == 0 && is_started == 1" class="lesson-item current">
                <!-- <div class="img-lesson">
                                    <img :src="lesson.lesson_img" alt="">
                                </div> -->
                <div class="desc-lesson">
                  <div class="title-lesson">
                    <!-- <img src="/themes/web/assets/images/icon/icon-fire.svg" alt=""> -->
                    <!-- <img v-if="lesson.status == 'inprogress'" src="/themes/web/assets/images/icon/icon-fire.svg" alt="">
                                        <img v-else-if="lesson.status == 'not-started'" src="/themes/web/assets/images/icon/icon-lock-2.svg" alt=""> -->
                    <span>Lesson {{ index + 1 }}</span>
                  </div>
                  <h4>{{ lesson.lesson_name }}</h4>
                </div>
                <div v-if="lesson.status == 'inprogress'" class="btn-play">
                  <div>
                    <p class="status-lesson">In-Progress</p>
                    <p class="value-process">
                      {{ lesson.process }}/{{ lesson.total }} Packages
                    </p>
                  </div>
                  <router-link :to="{
                    path:
                      '/lesson-package/' +
                      class_id +
                      '/' +
                      course_id +
                      '-' +
                      moduleCurent.id +
                      '-' +
                      lesson.id,
                  }">
                    <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png"
                      alt="" />
                  </router-link>
                </div>
                <div v-else-if="lesson.status == 'not-started'" class="btn-play">
                  <div class="btn-play">
                    <div>
                      <p class="status-lesson" style="color: #fc7a1b">To do</p>
                      <p class="value-process">
                        {{ lesson.process }}/{{ lesson.total }} Packages
                      </p>
                    </div>
                    <router-link :to="{
                      path:
                        '/lesson-package/' +
                        class_id +
                        '/' +
                        course_id +
                        '-' +
                        moduleCurent.id +
                        '-' +
                        lesson.id,
                    }">
                      <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png"
                        alt="" />
                    </router-link>
                  </div>
                </div>
              </div>

              <div v-else-if="lesson.lock == 1 || is_started == 0" class="lesson-item notstart">
                <!-- <p class="id-lesson">{{ module.id }}</p> -->
                <!-- <div class="img-lesson">
                                    <img :src="lesson.lesson_img" alt="">
                                </div> -->
                <div class="desc-lesson">
                  <div class="title-lesson">
                    <img src="/themes/web/assets/images/icon/icon-lock-2.svg" alt="" />
                    <span>Lesson {{ index + 1 }}</span>
                  </div>
                  <h4>{{ lesson.lesson_name }}</h4>
                </div>
                <div class="btn-play">
                  <div class="btn-play">
                    <div>
                      <p class="status-lesson">Not started</p>
                      <p class="value-process">
                        {{ lesson.process }}/{{ lesson.total }} Packages
                      </p>
                    </div>
                    <img src="/themes/web/assets/images/icon/icon-play-2.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="
              tests && tests.lock == 0 && tests.id != 0 && is_started == 1
            " class="lesson-item current">
              <!-- <div class="img-lesson">
                                <img :src="tests.lesson_img" alt="">
                            </div> -->
              <div class="desc-lesson">
                <div class="title-lesson">
                  <!-- <img v-if="lesson.status == 'inprogress'" src="/themes/web/assets/images/icon/icon-fire.svg" alt="">
                                    <img v-else-if="lesson.status == 'not-started'" src="/themes/web/assets/images/icon/icon-lock-2.svg" alt=""> -->
                  <!-- <img src="/themes/web/assets/images/icon/icon-fire.svg" alt=""> -->
                  <span>End of Module</span>
                </div>
                <h4>{{ tests.test_name }}</h4>
              </div>
              <!-- <div v-if="tests.status == 'notpass'" class="btn-play">
                                <p class="status-lesson" style="color: #FC7A1B;">To do</p>
                                <div @click="doTest(tests)">
                                    <img style="width: 90px; cursor: pointer;" src="/themes/web/assets/images/icon/btn-play.png" alt="">
                                </div>
                            </div> -->
              <div v-if="tests.status == 'pass'" class="btn-play">
                <p class="status-lesson" style="color: #a35cdb">Completed</p>
                <div @click="doTest(tests)">
                  <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png" alt="" />
                </div>
              </div>
              <div v-else-if="tests.status == 'notpass'" class="btn-play">
                <div style="
                    display: flex;
                    align-items: end;
                    flex-direction: column;
                  ">
                  <p class="status-lesson" style="color: #a35cdb">Completed</p>
                  <p style="
                      color: #ff0000;
                      font-size: 12px;
                      text-wrap: nowrap;
                      margin-top: 7px;
                    ">
                    You did not pass this test
                  </p>
                </div>
                <div @click="doTest(tests)">
                  <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png" alt="" />
                </div>
              </div>
              <div v-else class="btn-play">
                <p class="status-lesson" v-if="tests.status == TestStatus.ON_GOING" style="color: #fc7a1b">
                  To do
                </p>
                <p class="status-lesson" v-else-if="tests.status == TestStatus.INPROGRESS" style="color: #58cc02">
                  In Progress
                </p>
                <p class="status-lesson" v-else-if="tests.status == TestStatus.SUBMITED" style="color: #a560eb">
                  Submitted
                </p>
                <p class="status-lesson" v-else-if="tests.status == TestStatus.COMPLETED" style="color: #a560eb">
                  Completed
                </p>
                <p class="status-lesson" v-else-if="tests.status == TestStatus.NEED_RESUBMIT" style="color: #fc7a1b">
                  Allow retry
                </p>
                <div @click="doTest(tests)">
                  <img style="width: 90px; cursor: pointer" src="/themes/web/assets/images/icon/btn-play.png" alt="" />
                </div>
              </div>
            </div>
            <div v-else-if="
              (tests && tests.lock == 1 && tests.id != 0) ||
              (tests && is_started == 0)
            " class="lesson-item notstart">
              <!-- <div class="img-lesson">
                                <img :src="tests.lesson_img" alt="">
                            </div> -->
              <div class="desc-lesson">
                <div class="title-lesson">
                  <img src="/themes/web/assets/images/icon/icon-lock-2.svg" alt="" />
                  <span>End of Module</span>
                </div>
                <h4>{{ tests.test_name }}</h4>
              </div>
              <div class="btn-play">
                <div class="btn-play">
                  <p class="status-lesson">Not started</p>
                  <img src="/themes/web/assets/images/icon/icon-play-2.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="
            moduleCurent.status == 'completed' &&
            is_structured == 1 &&
            moduleCurent.sub_status == 'new_completed'
          " class="unlock-new-unit">
            <img src="/themes/web/assets/images/icon/button-lock.svg" alt="" />
            <!-- <h4 v-if="indexLesson != lessons.length">CONGRATULATIONS! <br> YOU CAN NOW UNLOCK LESSON {{ indexLesson + 1 }}.</h4> -->
            <h4>
              CONGRATULATIONS! <br />
              YOU CAN NOW UNLOCK MODULE {{ indexModule + 1 }}.
            </h4>
            <button class="igs-btn" @click="NextModule(moduleCurent)">
              Start
            </button>
          </div>
        </div>
        <div v-else-if="moduleCurent.type_code == 'end_of_semester'" class="content-right" style="width: 100%">
          <div class="semeter-test">
            <h5 v-if="moduleCurent.lock == 1" class="status status-notstarted">
              Not Started
            </h5>
            <h5 v-else-if="semeter_test.status == TestStatus.ON_GOING" class="status status-todo">
              To do
            </h5>
            <h5 v-else-if="semeter_test.status == TestStatus.SUBMITED" class="status status-submitted">
              Submitted
            </h5>
            <h5 v-else-if="semeter_test.status == TestStatus.NEED_RESUBMIT" class="status status-resubmit">
              Allow retry
            </h5>
            <h5 v-else-if="semeter_test.status == TestStatus.COMPLETED" class="status status-completed">
              Completed
            </h5>

            <h2 class="title">End-of-semeter test</h2>
            <p class="desc-1" v-if="
              semeter_test.status == TestStatus.COMPLETED &&
              semeter_test.is_pass == 0
            ">
              You're so close! Don't give up.
            </p>
            <div class="message" v-if="moduleCurent.lock == 0">
              <p v-if="
                semeter_test.status == TestStatus.ON_GOING &&
                semeter_test.lock == 1
              ">
                Hi everyone! Just a heads up that a test is coming soon.
              </p>
              <p v-else-if="
                semeter_test.status == TestStatus.ON_GOING &&
                semeter_test.lock == 0
              ">
                Wishing you all the best on your test!
              </p>
              <p v-else-if="semeter_test.status == TestStatus.SUBMITED">
                Great work on your test! Review your answer while score is
                coming.
              </p>
              <p v-else-if="semeter_test.status == TestStatus.COMPLETED">
                Finished grading! Go see your score.
              </p>
              <p v-else-if="semeter_test.status == TestStatus.NEED_RESUBMIT">
                Almost there! Keep trying.
              </p>
            </div>
            <div class="message" v-else>
              <p>Ready for the test? Finish all modules first!</p>
            </div>
            <button v-if="moduleCurent.lock == 1" class="igs-btn disable">
              Let's Go
            </button>
            <button v-else @click="semeter_test.lock == 1 ? '' : doTestSemeter(semeter_test)"
              :class="semeter_test.lock == 1 ? 'igs-btn disable' : 'igs-btn'">
              Let's Go
            </button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <theme-desc-modal class="" ref="themeDesc"></theme-desc-modal>
    </div>
    <div>
      <change-course-modal @fetch="fetch()" :courseId.sync="course_id" :classId.sync="class_id" class=""
        ref="changeCourse"></change-course-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  getModule,
  getAllCourse,
  getScores,
  TestStatus,
  NextModule,
} from "../../models/dashboard";
import themeDescModal from "../modal/Learning/themeDescModal.vue";
import changeCourseModal from "../modal/Learning/changeCourseModal.vue";
import { truncateTo2Decimals } from "../../utils/utils";
import Popper from "vue-popperjs";

export default {
  name: "Subject",
  components: { themeDescModal, changeCourseModal },
  title: "Subject",

  data() {
    return {
      semeter_test: "",
      view_test: false,
      default_semeter_img:
        "/themes/web/assets/images/icon/subject/theme-semeter-test.svg",
      TestStatus,
      date_expire: "Dec 31st, 2023",
      comming_expire: false,
      showPopup: null,
      course_id: this.$route.params.course_id,
      class_id: this.$route.params.class_id,
      lessons: [],
      modules: [],
      moduleCurent: {},
      lessonCurrent: {},
      indexModule: 1,
      indexLesson: 1,
      showMore: false,
      limit: 120,
      course_name: "",
      course_grade: 0,
      current_grade: 0,
      courses: [],
      course_desc: "",
      subject_name: "",
      course_img: "",
      pacing: 1,
      total_lessons: 0,
      total_tests: 0,
      is_structured: 1,
      tests: null,
      is_started: 1,
      sub_status: "",
    };
  },

  watch: {
    course_id() {
      this.$store.commit("setLoading", true);
      this.fetch();
    },
  },

  created() {
    this.$store.dispatch("SET_USER_INFO");
    this.$store.commit("setLoading", true);
    this.fetch();
  },
  beforeDestroy() {
    sessionStorage.removeItem("visited_" + this.$route.path);
  },

  mounted() {

    if (this.$store.getters.isShowMenu) {
      $("#subject .right").css({ left: "130px " });
      $("#assignment .right").css({ left: "130px" });
      $(".popup-modal").css({ left: "130px" });
      $("#lesson-package >.right").css({ left: "130px" });
    } else {
      $("#assignment .right").css({ left: "50px" });
      $("#subject .right").css({ left: "50px" });
      $(".popup-modal").css({ left: "50px" });
      $("#lesson-package >.right").css({ left: "50px" });
    }
  },

  computed: {
    user_info() {
      return this.$store.state.user_info;
    },
    truncatedText() {
      return this.course_desc.slice(0, this.limit);
    },
    isTruncated() {
      return this.course_desc.length > this.limit;
    },
    displayText() {
      return this.showMore || !this.isTruncated
        ? this.course_desc
        : this.truncatedText + "...";
    },
    displayDate() {
      var date = new Date(this.date_expire);

      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var suffixes = ["st", "nd", "rd", "th"];

      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();

      var suffix;
      if (day % 10 === 1 && day !== 11) {
        suffix = suffixes[0];
      } else if (day % 10 === 2 && day !== 12) {
        suffix = suffixes[1];
      } else if (day % 10 === 3 && day !== 13) {
        suffix = suffixes[2];
      } else {
        suffix = suffixes[3];
      }

      var formattedDate = months[monthIndex] + " " + day + suffix + ", " + year;
      return formattedDate;
    },
  },

  methods: {
    viewGradebook() {
      this.$router.push({
        name: "gradebook",
        params: { class_id: this.class_id }
      })
    },
    truncateTo2Decimals,
    doTest(test) {
      // this.$router.push({ name: 'test_detail', params: { test, class_id:  this.class_id, course_id: this.course_id, module_id: this.moduleCurent.id} });
      this.$store.commit("setCurrentLessonPackage", {
        type: 3,
        status: test.status,
        from_lsp: false,
      });

      this.$router.push({
        name: "test_detail",
        query: {
          test: JSON.stringify(test),
          type: "end_of_module",
          class_id: this.class_id,
          course_id: this.course_id,
          module_id: this.moduleCurent.id,
        },
      });
    },
    doTestSemeter(test) {
      this.$store.commit("setCurrentLessonPackage", {
        type: 3,
        status: test.status,
        from_lsp: false,
      });
      this.$router.push({
        name: "test_detail",
        query: {
          test: JSON.stringify(test),
          type: "end_of_semester",
          class_id: this.class_id,
          course_id: this.course_id,
          module_id: this.moduleCurent.id,
        },
      });
    },
    fetch(page = 1) {
      this.getScores();
      this.getAllCourse();
      this.getModule();
    },
    showToolTipModule(e) { },
    showStatusPace(n) {
      if (n == 1) {
        $(".tool-tip-pace").css({
          left: -$(".tool-tip-pace").width() / 2 + 10,
          display: "block",
          background: "rgba(35, 118, 168, 1)",
        });
      } else if (n == 2) {
        $(".tool-tip-pace").css({
          left: -$(".tool-tip-pace").width() / 2 + 10,
          display: "block",
          background: "rgba(189, 43, 17, 1)",
        });
      } else if (n == 3) {
        $(".tool-tip-pace").css({
          left: -$(".tool-tip-pace").width() / 2 + 10,
          display: "block",
          background: "rgba(39, 174, 96, 1)",
        });
      }
    },
    hideStatusPace() {
      $(".tool-tip-pace").css({
        display: "none",
      });
    },
    getScores() {
      const params = {
        // page: 1,
        // rowsPerPage: 100,
        // colfiler: {
        class_id: this.class_id,
        // text_search: localStorage.getItem('student_code'),
        text_search: "",
        student_code: localStorage.getItem("student_code"),
        // course_id: this.course_id
        // }
      };
      axios.all([getScores(params)]).then(
        axios.spread((report_response) => {
          this.course_grade = report_response.data.data
            ? report_response.data.data[0].course_grade
            : 0;
          this.current_grade = report_response.data.data
            ? report_response.data.data[0].current_grade
            : 0;
        })
      );
    },
    getAllCourse() {
      const params = {
        grade_id: this.user_info.grade_id,
        program_id: 0,
      };
      axios.all([getAllCourse(params)]).then(
        axios.spread((report_response) => {
          if (report_response.data.code != 0) {
            return;
          }
          this.courses = report_response.data.results;
        })
      );
    },
    async seeMore() {
      const cfm = await this.$refs.themeDesc.show({
        type: 1,
        lang: this.lang,
        index: this.indexModule,
        all_index: this.modules.length,

        total_lessons: this.total_lessons,
        total_tests: this.total_tests,

        course_name: this.course_name,
        subject_name: this.subject_name,
        course_img: this.course_img,
        course_desc: this.course_desc,
      });
      if (!cfm) {
        return false;
      }
    },
    async showModuleDesc() {
      const cfm = await this.$refs.themeDesc.show({
        type: 2,
        lang: this.lang,
        desc: this.moduleCurent.desc,
      });
      if (!cfm) {
        return false;
      }
    },
    async changeCourse() {
      const cfm = await this.$refs.changeCourse.show({
        lang: this.lang,
        courses: this.courses,
        id_current_class: this.class_id,
      });
      if (!cfm) {
        return false;
      }
      return;
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    goHome() {
      $("#subject").css("transform", "translateX(0)");
    },
    getModule() {
      const params = {
        course_id: this.course_id,
        class_id: this.class_id,
      };
      axios.all([getModule(params)]).then(
        axios.spread((report_response) => {
          if (report_response.data.code != 0) {
            return;
          }

          this.modules = report_response.data.results.modules;
          this.course_name = report_response.data.results.course_name;
          this.course_img = report_response.data.results.illustration_url;
          this.course_desc = report_response.data.results.desc;
          this.subject_name = report_response.data.results.subject_name;
          this.total_lessons = report_response.data.results.total_lesson;
          this.pacing = report_response.data.results.pacing;
          this.is_structured = report_response.data.results.is_structured;
          this.is_started = report_response.data.results.is_started;
          this.date_expire = report_response.data.results.end_date;
          this.comming_expire = report_response.data.results.comming_expire;
          this.total_tests = report_response.data.results.total_test;
          this.sub_status = report_response.data.results.sub_status;

          if (
            (this.$store.getters.getCurrentModule && this.$store.getters.getCurrentModule.class_id == this.class_id &&
              this.$store.getters.getCurrentModule.course_id == this.course_id)
          ) {
            this.moduleCurent = this.modules.find(
              (item) =>
                item.id == (this.$store.getters.getCurrentModule.module_id)
            );
            this.lessonCurrent = this.moduleCurent.lessons
              ? this.moduleCurent.lessons[0]
              : "";
            this.lessons = this.moduleCurent.lessons;
            this.tests = this.moduleCurent.test;
            this.semeter_test = this.moduleCurent.semeter_test;
            this.$store.dispatch("setCurrentModule", null);
          } else {
            this.moduleCurent = this.modules[0];
            this.lessonCurrent = this.moduleCurent.lessons
              ? this.moduleCurent.lessons[0]
              : "";
            this.lessons = this.modules[0].lessons;
            this.tests = this.modules[0].test;
            this.semeter_test = this.modules[0].semeter_test;
          }
          this.$store.commit("setLoading", false);
        })
      );
    },
    changeModule(module, index) {
      this.indexModule = index + 1;
      this.moduleCurent = module;
      this.tests = module.test;
      this.semeter_test = module.semeter_test;
      this.lessonCurrent = this.moduleCurent.lessons
        ? this.moduleCurent.lessons[0]
        : "";
      this.lessons = this.moduleCurent.lessons;
      // this.$store.dispatch("setCurrentModule", {
      //   moduleId: this.moduleCurent.id,
      //   courseId: this.course_id,
      //   classId: this.class_id,
      // });
    },
    NextModule(moduleCurent) {
      moduleCurent.sub_status = "";
      const params = {
        course_id: this.course_id,
        module_id: moduleCurent.id,
        class_id: this.class_id,
      };
      axios.all([NextModule(params)]).then(axios.spread((response) => { }));
      this.changeModule(this.modules[this.indexModule], this.indexModule);
    },
    changeLesson(lesson, index) {
      this.lessonCurrent = lesson;
      this.indexLesson = index + 1;
    },
  },
};
</script>

<style scoped>
.gradebook-button {
  margin-top: 16px;
  width: fit-content;
  align-self: center;
  padding: 12px 16px;
  border-radius: 48px;
  background: white;
  color: #1D1D1F;
  font-size: 12px;
  border: 1px solid black;
  box-shadow: 4px 4px black;
}

.igs-btn.disable {
  border: 1px solid var(--Cloud-Dark, #cfcfcf) !important;
  background: var(--Cloud-Light, #ddd) !important;
  box-shadow: 4px 4px 0px 0px #cfcfcf !important;
}

.semeter-test {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 200px 40px;
}

.semeter-test .desc-1 {
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-align: center;
  color: #ff3d54;
}

.semeter-test .title {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
  color: #4c4c4c;
  margin-bottom: 20px;
}

.semeter-test .message {
  /* width: 524px; */
  padding: 16px 24px 16px 24px;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid #dddddd;
  background: #f8fafc;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #777777;
  margin-bottom: 18px;
  /* text-wrap: nowrap; */
}

.semeter-test .status {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
  margin-bottom: 20px;
  padding: 8px 16px 8px 16px;
  border-radius: 24px;
}

.semeter-test .status-notstarted {
  color: #777777;
  background: var(--Cloud-Light, #ddd);
}

.semeter-test .status-todo {
  color: #fc7a1b;
  background-color: #ffe9da;
}

.semeter-test .status-submitted {
  color: #a560eb;
  background-color: #ead4ff;
}

.semeter-test .status-completed {
  color: #a560eb;
  background-color: #ead4ff;
}

.semeter-test .status-resubmit {
  color: #fc7a1b;
  background-color: #ffe9da;
}

.free-study .theme-item.completed {
  border-radius: 24.75px;
  border: 2px solid rgba(88, 204, 2, 0.8);
}

.free-study .theme-item.active .info-progress {
  background: rgba(165, 96, 235, 0.8);
}

.free-study .theme-item.ongoing {
  border-radius: 24.75px;
  /* border: 2px solid #A35CDB; */
  border: 2px solid rgba(2, 166, 231, 0.8);
}

.free-study .theme-item.not-start {
  border: 2px solid var(--Cloud-Dark, #cfcfcf);
}

.free-study .info-progress {
  border-radius: 0px 0px 0px 8px;
  height: 24px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}

.free-study .info-progress p {
  color: var(--Creme-Light, #fff);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  /* 200% */
}

.free-study .info-progress.completed {
  background: rgba(88, 204, 2, 0.8);
}

.free-study .info-progress.not-start {
  background: rgba(207, 207, 207, 0.8);
}

.free-study .info-progress.inprogress {
  background: rgba(2, 166, 231, 0.8);
}

.popper-1 {
  z-index: 999 !important;
  /* transform: none !important; */
  left: 225px !important;
  top: 0 !important;
}

.popper {
  top: 20px !important;
  z-index: 999 !important;
}

.icon-info:hover .tool-tip-info {
  display: block;
}

.tool-tip-info {
  display: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px 16px;
  position: absolute;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.25);
  width: 320px;
  top: 30px;
  left: -150px;
  z-index: 99;
}

.tool-tip-info p {
  color: var(--Liquorice-Light, #777);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.tool-tip-info p:nth-child(1) {
  margin-bottom: 10px;
}

.tool-tip-pace {
  position: relative;
  border-radius: 24px;
  width: fit-content;
  display: none;
  top: 25px;
}

.tool-tip-pace p {
  color: var(--Creme-Light, #fff);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 8px 16px;
  text-wrap: nowrap;
}

.progress {
  margin-top: 10px;
  position: relative;
  opacity: 1;
  border-radius: 5px;
  height: 10px;
  width: 100%;
  padding: 2px;
}

.progress-load {
  border-radius: 80px;
  background: rgba(0, 175, 255, 0.15);
  transition: none 0s ease 0s;
  height: 10px;
  position: relative;
  width: 100%;
}

.status-pace {
  cursor: pointer;
  width: 24px;
  height: 10px;
  border-radius: 1000px;
  background: #00afff;
  position: relative;
  left: 60%;
  top: 0;
  /* bottom: -12px; */
}

.status-pace.slow {
  background: #ff4141;
  width: 40px;
  border-radius: 1000px 0 0 1000px;
}

.status-pace.fast {
  background: #58cc02;
  width: 40px;
  border-radius: 0 1000px 1000px 0;
}

.line-pace {
  width: 1px;
  height: 24px;
  position: absolute;
  border-right: 2px dotted #1d1d1f;
  left: 50%;
  transform: translateX(-50%);
  top: -8px;
}

.line-pace.slow {
  left: 100%;
}

.line-pace.fast {
  left: 0%;
}

.p-pace-1 {
  color: var(--Liquorice-Dark, #4c4c4c);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-wrap: nowrap;
}

.p-pace {
  color: var(--Liquorice-Dark, #4c4c4c);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-wrap: nowrap;
}

.circle-pace-1 {
  width: 50px;
  height: 30px;
  padding: 8px;
  display: flex;
  align-items: center;
  border-radius: 100px;
  border-radius: 100px;
  border: 1px solid var(--Blueberry-Light, #02a6e7);
  background: var(--Very-Light-Blueberry, #dbeafe);
  justify-content: center;
}

.circle-pace {
  width: 50px;
  height: 30px;
  padding: 8px;
  display: flex;
  align-items: center;
  border-radius: 100px;
  border: 1px solid var(--Kiwi-Light, #58cc02);
  background: var(--Kiwi-Verylight, #e9ffd9);
  justify-content: center;
}

.circle-pace p {
  color: var(--Kiwi-Light, #58cc02);
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.circle-pace-1 p {
  color: var(--Blueberry-Light, #02a6e7);
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.popup {
  position: absolute;
  background-color: red;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  /* Định vị popup */
  right: 0;
  top: 0;
}

#subject {
  transition: all 0.5s !important;
  /* width: 100%;
        display: flex;
        height: 100%;
        justify-content: space-between; */
}

#subject .right {
  background: #ffffff;
  height: 100%;
  /* width: calc(100% - 56px); */
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.25);
  border-radius: 24px 0px 0px 24px;
  padding: 32px 24px;
  overflow: auto;
  flex: 1;
  position: fixed;
  /* left: 50px; */
  right: 0;
}

#subject>.left {
  width: 56px;
}

.btn-close {
  margin-top: 120px;
  width: 32px;
  height: 124px;
  background: #02a6e7;
  border: 1px solid #2376a8;
  border-radius: 24px 0px 0px 24px;
  transform: matrix(-1, 0, 0, 1, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.btn-close img {
  transform: rotate(180deg);
}

.header .desc {
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.02em;
  color: #4c4c4c;
  margin-bottom: 4px;
}

.header {
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px solid #cfcfcf;
  margin-bottom: 26px;
  /* height: 160px; */
}

.header .title-subject {
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.02em;
  color: #4c4c4c;
  display: flex;
  background: rgba(204, 151, 239, 0.25);
  border: 2px solid rgba(165, 96, 235, 0.25);
  border-radius: 16px;
  align-items: center;
  padding: 4px 8px;
  justify-content: space-between;
  margin-bottom: 4px;
}

.header .title-subject h4 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 20px;
}

.left-header {
  display: flex;
  flex-direction: column;
  width: 330px;
  padding-right: 16px;
  border-right: 1px solid #cfcfcf;
}

.right-header {
  display: flex;
  gap: 8px;
  width: 70%;
  margin-left: 16px;
  height: 100%;
  align-items: center;
  overflow-x: auto;
}

.right-header::-webkit-scrollbar {
  height: 6px;
  display: none;
  /* Ẩn mặc định */
}

.right-header:hover::-webkit-scrollbar {
  display: block;
  /* Hiện khi hover */
}

.right-header::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.right-header::-webkit-scrollbar-track {
  background: transparent;
}

.right-header>div {
  display: flex;
  gap: 15px;
  align-items: center;
}

.left-header .desc {
  font-weight: 400;
  font-size: 12px;
  color: #4c4c4c;
  opacity: 0.6;
  letter-spacing: 0.02em;
}

.theme-item {
  position: relative;
  height: 80px;
  width: 80px;
  border: 4px solid #cfcfcf;
  border-radius: 24.75px;
  /* background-color: #CFCFCF; */
  position: relative;
  overflow: hidden;
  cursor: pointer;
  padding: 2px;
}

.tool-tip-complete {
  border-radius: 24px;
  background: var(--Rasberry-Light, #ff3d54);
  padding: 16px;
  width: 320px;
  /* display: none; */
}

.tool-tip-complete p {
  color: var(--Creme-Light, #fff);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.theme-item.active {
  border: 4px solid #a35cdb;
}

.name-theme.active {
  color: #a35cdb;
}

.theme-item>img:nth-child(1) {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.icon-status {
  position: absolute;
  right: -2px;
  top: -2px;
  z-index: 2;
}

.dot {
  background: #cfcfcf;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dot.active {
  background: #58cc02;
}

.name-theme {
  color: #4c4c4c;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  margin-top: 2px;
  white-space: nowrap;
}

.body {
  display: flex;
  width: 100%;
  /* gap: 180px; */
  /* background-color: red; */
}

.content-left .theme-card>img {
  border: 1px solid #777777;
  /* filter: drop-shadow(0px 8px 0px #4F4F4F) drop-shadow(8px 0px 4px rgba(0, 0, 0, 0.25)); */
  border-radius: 8px;
  width: 300px;
  height: 200px;
}

.content-left .theme-card {
  position: relative;
  width: 300px;
  height: 200px;
}

.content-left {
  margin-right: 26px;
}

.status-unit-item {
  width: 54px;
  height: 32px;
  border-width: 1px 1px 4px 0px;
  border-style: solid;
  border-radius: 0px 16px 16px 0px;
}

.status-unit-item.lock {
  background: #dddddd;
  border-color: #777777;
}

.status-unit-item.checked {
  background: rgba(88, 204, 2, 0.8);
  border-color: #27ae60;
}

.status-unit-item.unlock {
  background: radial-gradient(109.13% 100% at 50% 100%,
      #cc97ef 0%,
      #ba53ea 100%);
  border-color: #8549ba;
}

.status-unit-list {
  position: absolute;
  z-index: 2;
  left: 300px;
  top: 15px;
  display: flex;
  flex-direction: column;
}

.status-desc {
  display: flex;
  gap: 8px;
  cursor: pointer;
  height: 37px;
  transition: all 0.2s;
  width: 55px;
}

.status-desc.active {
  width: 120px;
  color: #fff !important;
  gap: 0;
}

.status-desc.active span {
  padding: 0;
}

.status-desc span {
  font-weight: 700;
  font-size: 16px;
  white-space: nowrap;
  align-items: center;
  display: flex;
  padding-right: 16px;
}

.status-desc>div {
  margin-left: 8px;
  min-width: 45px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-desc img {
  /* width: 100%; */
}

.status-desc.checked {
  color: #4c4c4c;
  border-radius: 0px 16px 16px 0px;
  border-top: 1px solid #27ae60;
  border-right: 1px solid #27ae60;
  border-bottom: 4px solid #27ae60;
  background: rgba(88, 204, 2, 0.8);
}

.status-desc.unlock {
  color: #a560eb;
  border-radius: 0px 16px 16px 0px;
  border-top: 1px solid var(--jelly-dark, #8549ba);
  border-right: 1px solid var(--jelly-dark, #8549ba);
  border-bottom: 4px solid var(--jelly-dark, #8549ba);
  background: var(--gradient-2,
      radial-gradient(109.13% 100% at 50% 100%, #cc97ef 0%, #ba53ea 100%));
}

.status-desc.lock {
  color: #cfcfcf;
  border-radius: 0px 16px 16px 0px;
  border-top: 1px solid var(--liquorice-light, #777);
  border-right: 1px solid var(--liquorice-light, #777);
  border-bottom: 4px solid var(--liquorice-light, #777);
  background: var(--cloud-light, #ddd);
}

.content-right {
  /* margin-left: 125px; */
  border: 2px solid #ead4ff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  border-radius: 24px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.desc-unit {
  background: radial-gradient(109.13% 100% at 50% 100%,
      #cc97ef 0%,
      #ba53ea 100%);
  padding: 24px 24px 40px 24px;
  border-radius: 24px 24px 0px 0px;
}

.number-unit {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.number-unit>div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.number-unit>div span {
  font-size: 16px;
  letter-spacing: 0.02em;
  font-weight: 300;
}

.desc-unit h2 {
  font-weight: 700;
  font-size: 32px;
  letter-spacing: 0.02em;
  margin-bottom: 18px;
}

.desc-unit>p {
  letter-spacing: 0.02em;
  font-weight: 100;
  font-size: 16px;
}

.lesson-item {
  height: 80px;
  padding: 0 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list-lesson {
  max-height: 320px;
  overflow-y: auto;
}

.img-lesson {
  min-height: 64px;
  min-width: 64px;
  border-radius: 16px;
  margin-right: 16px;
  position: relative;
}

.img-lesson img {
  width: 64px;
  height: 64px;
}

.status-lesson {
  letter-spacing: 0.05em;
  font-weight: 700;
  font-size: 16px;
  white-space: nowrap;
}

.lesson-item.completed .status-lesson {
  color: #a560eb;
}

.lesson-item.current .status-lesson {
  color: #58cc02;
}

.lesson-item.notstart .status-lesson {
  color: #777777;
}

.id-lesson {
  letter-spacing: 0.05em;
  font-weight: 700;
  font-size: 20px;
  margin-right: 17px;
}

.lesson-item.completed .id-lesson {
  color: #4c4c4c;
}

.lesson-item.current .id-lesson {
  color: #a35cdb;
}

.lesson-item.notstart .id-lesson {
  color: #777777;
}

.lesson-item.notstart {
  background: #ead4ff;
  opacity: 0.25;
}

.btn-play {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  align-items: center;
  /* margin-left: 90px; */
}

.title-lesson {
  text-wrap: nowrap;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  font-weight: 700;
  font-size: 16px;
  gap: 8px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lesson-item.notstart .title-lesson {
  /* color: #777777; */
  color: #4c4c4c;
}

.lesson-item.current .title-lesson {
  /* color: #A35CDB; */
  color: #4c4c4c;
}

.lesson-item.completed .title-lesson {
  /* color: #4C4C4C; */
  color: #4c4c4c;
}

.desc-lesson {
  max-width: calc(100% - 250px);
}

.desc-lesson h4 {
  font-weight: 700;
  font-size: 20px;
  letter-spacing: 0.02em;
  color: #000000;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-y: auto;
  max-height: 47px;
  text-wrap: nowrap;
}

.unit-details {
  margin-top: 24px;
  width: 300px;
  display: flex;
  flex-direction: column;
}

.unit-details>p {
  color: #777777;
  opacity: 0.6;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.02em;
  margin-bottom: 8px;
}

.unit-details>h4 {
  color: #4c4c4c;
  letter-spacing: 0.02em;
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 8px;
  word-wrap: break-word;
}

.unit-details>div>p {
  color: #4c4c4c;
  letter-spacing: 0.02em;
  font-weight: 100;
  font-size: 16px;
}

.unit-details>div span {
  color: #02a6e7;
  font-weight: 900;
  text-decoration: underline;
  cursor: pointer;
}

.unlock-new-unit {
  height: 96px;
  width: 100%;
  background: #a560eb;
  padding: 0 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 0 24px 24px;
}

.unlock-new-unit h4 {
  width: 100%;
  margin-left: 50px;
}

.img-inactive {
  /* opacity: 0.5; 
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%); */
}

.structured {
  color: var(--Blueberry-Light, #02a6e7);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.24px;
}

.non-structured {
  color: #fc7a1b;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.24px;
}

.value-process {
  color: #777777;
  font-size: 12px;
  margin-top: 8px;
  text-wrap: nowrap;
}

.expire {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #ff3d54 !important;
  margin-top: 25px;
  opacity: 1 !important;
}
</style>
